module.exports = __webpack_public_path__ + "images/164_640.jpg";